import React from "react";
import PayrollRomms from "../../payroll/PayrollRomms";

interface TradePayablesRommsProps {
  onBack: () => void;
}

export default function TradePayablesRomms({ onBack }: TradePayablesRommsProps) {
  return <PayrollRomms onBack={onBack} onComplete={() => {}} workspace="Trade Payables" />;
}

